/**
 * Dependency injection symbols for GTD Domain
 * 
 * Using Symbol-based identifiers to avoid circular dependencies
 * and ensure type safety in dependency injection.
 */

// Inbox Management Bounded Context
export const TYPES = {
  // Inbox Management Bounded Context
  InboxItemApplicationService: Symbol.for('InboxItemApplicationService'),
  InboxItemAggregateRepository: Symbol.for('InboxItemAggregateRepository'),
  GTDProcessingWorkflowService: Symbol.for('GTDProcessingWorkflowService'),
  InboxImportExportService: Symbol.for('InboxImportExportService'),
  
  // Project Management Bounded Context
  ProjectApplicationService: Symbol.for('ProjectApplicationService'),
  ProjectReadService: Symbol.for('ProjectReadService'),
  ProjectRepository: Symbol.for('ProjectRepository'),
  NextActionAggregateRepository: Symbol.for('NextActionAggregateRepository'),
  NextActionWriteService: Symbol.for('NextActionWriteService'),
  NextActionReadService: Symbol.for('NextActionReadService'),
  
  // Task Management Bounded Context
  ITaskRepository: Symbol.for('ITaskRepository'),
  TaskMongoRepository: Symbol.for('TaskMongoRepository'),
  InboxFileRepository: Symbol.for('InboxFileRepository'),
  NextActionsFileRepository: Symbol.for('NextActionsFileRepository'),
  
  // Design Implementation Coordination Bounded Context
  DesignImplementationFlowRepository: Symbol.for('DesignImplementationFlowRepository'),
  DesignImplementationFlowApplicationService: Symbol.for('DesignImplementationFlowApplicationService'),
  DesignImplementationFlowReadService: Symbol.for('DesignImplementationFlowReadService')
} as const;

// Type helpers for better IntelliSense
export type DITypes = typeof TYPES;